import { CSSProperties } from 'react';
import cn from 'classnames';
import styles from './skeleton.module.scss';

export interface IProps {
  /**
   * Width of the skeleton. Accepts a number (pixels) or a string (e.g. '50%', '10rem').
   * If not provided, skeleton takes 100% of container width.
   */
  width?: CSSProperties['width'],
  /**
   * Background variant of the skeleton.
   * 'default' — for use on lighter backgrounds.
   * 'darker' — for use on darker backgrounds.
   */
  variant?: 'default' | 'darker',
}

function Skeleton({ width = '100%', variant = 'default' }: IProps) {
  return (
    <div
      className={ styles.wrapper }
      style={ { width } }
      data-test="loader"
    >
      <div className={ cn(styles.skeleton, styles[variant]) } />
    </div>
  );
}

export default Skeleton;
